<template>
  <v-navigation-drawer
    v-model="drawer"
    clipped
    app
  >
    <div class="d-flex flex-column fill-height">
      <v-list>
        <v-list-item :to="{ name: 'dashboard' }" exact>
          <v-list-item-action>
            <v-icon>mdi-desktop-mac-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('主頁') }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>{{ $t('辦門號') }}</v-subheader>
        <v-list-item :to="{ name: 'apply' }" exact>
          <v-list-item-action>
            <v-icon>mdi-credit-card-plus-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('辦門號') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'apply.batch' }" v-if="$vuetify.breakpoint.mdAndUp && canBatch && isManager">
          <v-list-item-action>
            <v-icon>mdi-credit-card-multiple-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('大量辦門號') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'apply.logs' }">
          <v-list-item-action>
            <v-icon>mdi-card-search-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('辦門號記錄') }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>{{ $t('查證') }}</v-subheader>
        <v-list-item :to="{ name: 'query' }">
          <v-list-item-action>
            <v-icon>mdi-account-search</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('一般查證') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'batch' }" v-if="$vuetify.breakpoint.mdAndUp && canBatch">
          <v-list-item-action>
            <v-icon>mdi-layers-search</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('大量查證') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'logs' }">
          <v-list-item-action>
            <v-icon>mdi-text-box-search-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('查證紀錄') }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <template v-if="isManager">
          <v-subheader>{{ $t('其他') }}</v-subheader>
          <v-list-item :to="{ name: 'sims' }">
            <v-list-item-action>
              <v-icon>mdi-sim</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ $t('SIM卡庫存') }}</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="{ name: 'issues' }">
            <v-list-item-action>
              <v-icon>mdi-clipboard-alert-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ $t('問題件') }}</v-list-item-title>
          </v-list-item> -->
          <v-divider></v-divider>
        </template>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('登出') }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title class="text-center caption">ver. {{ buildNumber }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  props: {
    toggle: Boolean,
  },

  data() {
    return {
      buildNumber: process.env.MIX_BUILD_HASH,
    }
  },

  computed: {
    drawer: {
      get() {
        return this.toggle;
      },

      set(val) {
        this.$emit('update:toggle', val);
      },
    },

    ...mapGetters(['canBatch', 'isManager']),
  },

  methods: {
    match(name) {
      return this.$route.path.indexOf(name) > -1;
    },

    ...mapActions(['logout']),
  },
}
</script>

<style lang="scss" scoped>
  .toolbar {
    font-weight: bold;
    font-size: 18px;

    .text {
      padding-left: 15px;
      color: white;
      text-decoration:none;
    }
  }

  .logo {
    max-width: 40px;
  }
</style>
